module.exports = __webpack_public_path__ + "img/xpresso/funnel_checkout_success.jpg";